import * as React from 'react';

import { ApPlan } from '../../../sic-lib/types/ApPlan';
import { ApSchedulerContact } from '../../../sic-lib/types/ApSchedulerContact';
import { hasMatchingContactId } from '../../../sic-lib/utils/functionalFilters';
import { useAppSelector } from '../../../store/hooks';
import ApTemplateSelect from '../ApTemplateSelect/ApTemplateSelect';
import CommPlanEditor from '../CommPlanEditor/CommPlanEditor';
import CommTemplateEditor from '../CommTemplateEditor/CommTemplateEditor';

export default function SectionMessaging() {
    const buildStage = useAppSelector(state => {
        return state.communicator?.buildStage || 'EDIT';
    });

    const template = useAppSelector(state => {
        return state.communicator?.template || null;
    });

    const contacts = useAppSelector(state => {
        return state.communicator?.contacts || [];
    });

    const editContactId = useAppSelector(state => {
        return state.communicator?.editContactId || -1;
    });

    const [editContact, setEditContact] = React.useState<ApSchedulerContact | null>(null);

    React.useEffect(() => {
        const filteredContact = contacts.filter(hasMatchingContactId(editContactId))[0] || null;

        setEditContact(filteredContact);
    }, [editContactId]);

    return (
        <div className="apScheduler__panel--right">
            {
                /* Template is not assigned and no template has been set */
                buildStage === 'EDIT' && template === null && <ApTemplateSelect />
            }
            {
                /* Template is not assigned but template has been set */
                buildStage === 'EDIT' && template !== null && (
                    <CommTemplateEditor template={template} />
                )
            }
            {
                /* Template has been assigned to the contact list */
                buildStage === 'SCHEDULE' && editContact !== null && (
                    <CommPlanEditor
                        plan={editContact.actionPlan as ApPlan}
                        contactId={editContact.contactId}
                    />
                )
            }
        </div>
    );
}
